import React, { useState, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MenuHero from './components/MenuHero';
import CategoryFilter from './components/CategoryFilter';
import FilterBar from './components/FilterBar';
import MenuGrid from './components/MenuGrid';
import QuickOrderBanner from './components/QuickOrderBanner';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [dietaryFilter, setDietaryFilter] = useState('all');
  const [priceFilter, setPriceFilter] = useState('all');
  const [sortBy, setSortBy] = useState('popular');
  const [searchQuery, setSearchQuery] = useState('');

  const categories = [
  { id: 'all', name: 'All Items', icon: 'UtensilsCrossed', count: 16 },
  { id: 'chapati', name: 'Rolex Wraps', icon: 'Cookie', count: 4 },
  { id: 'snacks', name: 'Snacks', icon: 'Apple', count: 2 },
  { id: 'beverages', name: 'Beverages', icon: 'Coffee', count: 10 }];


  const menuItems = [
  {
    id: 1,
    name: "Beef Roll",
    description: "Delicious chapati rolled with seasoned beef, eggs, and fresh vegetables. A hearty and satisfying meal.",
    price: 25000,
    category: 'chapati',
    image: "/assets/images/Rolex_Beef-1781076149646.jpeg",
    imageAlt: "Beef rolex wrap with golden chapati filled with seasoned beef and vegetables on white plate",
    dietary: [
    { label: 'High Protein', icon: 'Dumbbell' }],
    ingredients: "Chapati, beef, eggs, tomatoes, onions, cabbage, spices",
    nutrition: { calories: 650, protein: 35 },
    prepTime: 15,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 2,
    name: "Chicken Roll",
    description: "Soft chapati wrapped with tender chicken, eggs, and crisp vegetables. A popular street food favorite.",
    price: 25000,
    category: 'chapati',
    image: "/assets/images/Veg_Rolex-1781077105472.jpeg",
    imageAlt: "Chicken rolex with grilled chicken and fresh vegetables wrapped in warm chapati",
    dietary: [
    { label: 'High Protein', icon: 'Dumbbell' }],
    ingredients: "Chapati, chicken, eggs, tomatoes, onions, cabbage, spices",
    nutrition: { calories: 580, protein: 32 },
    prepTime: 15,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 3,
    name: "Vegetable Roll",
    description: "Fresh chapati filled with eggs and a colorful mix of vegetables. Perfect for vegetarians.",
    price: 20000,
    category: 'vegetarian',
    image: "/assets/images/Rolex_Veg-1781076283880.jpeg",
    imageAlt: "Vegetable rolex with fresh vegetables and eggs wrapped in soft chapati",
    dietary: [
    { label: 'Vegetarian', icon: 'Leaf' }],
    ingredients: "Chapati, eggs, tomatoes, onions, cabbage, carrots, peppers",
    nutrition: { calories: 420, protein: 15 },
    prepTime: 12,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 4,
    name: "Egg Roll",
    description: "Simple yet delicious chapati rolled with scrambled eggs and vegetables. A quick and tasty option.",
    price: 15000,
    category: 'chapati',
    image: "/assets/images/Veg_Rolex-1781078431658.jpeg",
    imageAlt: "Egg rolex with fluffy scrambled eggs wrapped in golden chapati",
    dietary: [
    { label: 'Vegetarian', icon: 'Leaf' }],
    ingredients: "Chapati, eggs, tomatoes, onions, salt, pepper",
    nutrition: { calories: 380, protein: 18 },
    prepTime: 10,
    servingSize: 1,
    isPopular: false,
    isFavorite: false
  },
  {
    id: 5,
    name: "Water",
    description: "Refreshing bottled water to quench your thirst.",
    price: 2000,
    category: 'beverages',
    image: "https://images.unsplash.com/photo-1655079343782-f0fc4704753e",
    imageAlt: "Clear bottled water on white background",
    dietary: [
    { label: 'Vegan', icon: 'Sprout' }],
    ingredients: "Purified water",
    nutrition: { calories: 0, protein: 0 },
    prepTime: 0,
    servingSize: 1,
    isPopular: false,
    isFavorite: false
  },
  {
    id: 6,
    name: "Soda",
    description: "Chilled carbonated soft drink. Various flavors available.",
    price: 5000,
    category: 'beverages',
    image: "https://i.ibb.co/pjfZby1X/Sodas.png",
    imageAlt: "Cold soda bottle with condensation on glass",
    dietary: [],
    ingredients: "Carbonated water, sugar, flavoring",
    nutrition: { calories: 140, protein: 0 },
    prepTime: 0,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 7,
    name: "Fresh Juice",
    description: "Freshly squeezed fruit juice. Made to order with natural ingredients.",
    price: 15000,
    category: 'beverages',
    image: "/assets/images/Beverage_1-1781076755765.jpeg",
    imageAlt: "Fresh fruit juice in glass with colorful fruits",
    dietary: [
    { label: 'Vegan', icon: 'Sprout' }],
    ingredients: "Fresh fruits, water",
    nutrition: { calories: 120, protein: 1 },
    prepTime: 5,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 8,
    name: "Pepsi Can",
    description: "Classic Pepsi cola in a convenient can. Ice cold and refreshing.",
    price: 7000,
    category: 'beverages',
    image: "https://images.unsplash.com/photo-1629203851122-3726ecdf080e",
    imageAlt: "Pepsi can with condensation droplets on blue background",
    dietary: [],
    ingredients: "Carbonated water, sugar, caramel color, phosphoric acid, caffeine",
    nutrition: { calories: 150, protein: 0 },
    prepTime: 0,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 9,
    name: "Kikomando",
    description: "Chapati mixed with beans.",
    price: 15000,
    category: 'chapati',
    image: "https://i.ibb.co/5XHdq2Wz/Kikomando.jpg",
    imageAlt: "Traditional South Sudanese snack on plate",
    dietary: [],
    ingredients: "Local ingredients, spices",
    nutrition: { calories: 280, protein: 8 },
    prepTime: 10,
    servingSize: 1,
    isPopular: false,
    isFavorite: false
  },
  {
    id: 10,
    name: "Fruit Salad Combo",
    description: "Fresh seasonal fruits mixed together. A healthy and refreshing choice.",
    price: 20000,
    category: 'snacks',
    image: "/assets/images/Fruit_Salad-1781076940398.jpeg",
    imageAlt: "Colorful fresh fruit salad with mixed tropical fruits in bowl",
    dietary: [
    { label: 'Vegan', icon: 'Sprout' },
    { label: 'Healthy', icon: 'Heart' }],
    ingredients: "Seasonal fruits: watermelon, pineapple, mango, papaya, banana",
    nutrition: { calories: 180, protein: 2 },
    prepTime: 8,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 11,
    name: "Fresh Youghurt",
    description: "Traditional yoghurt. Locally sourced and naturally refreshing.",
    price: 15000,
    category: 'beverages',
    image: "/assets/images/Yoghurt-1781099819274.jpeg",
    imageAlt: "Traditional fresh beverage in glass with natural ingredients",
    dietary: [
    { label: 'Vegan', icon: 'Sprout' }],
    ingredients: "Natural ingredients, water",
    nutrition: { calories: 90, protein: 1 },
    prepTime: 5,
    servingSize: 1,
    isPopular: false,
    isFavorite: false
  },
  {
    id: 12,
    name: "Black Tea",
    description: "Hot black tea brewed to perfection. Simple and comforting.",
    price: 5000,
    category: 'beverages',
    image: "https://images.unsplash.com/photo-1632777012009-0ca895926882",
    imageAlt: "Cup of hot black tea with steam rising on saucer",
    dietary: [
    { label: 'Vegan', icon: 'Sprout' }],
    ingredients: "Black tea leaves, hot water",
    nutrition: { calories: 2, protein: 0 },
    prepTime: 5,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 13,
    name: "Africa Tea",
    description: "Traditional African tea blend with aromatic spices. Rich and flavorful.",
    price: 10000,
    category: 'beverages',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16d8340a4-1772253720983.png",
    imageAlt: "Traditional African spiced tea in decorative cup with spices",
    dietary: [
    { label: 'Vegan', icon: 'Sprout' }],
    ingredients: "Tea leaves, spices, hot water",
    nutrition: { calories: 15, protein: 0 },
    prepTime: 7,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 14,
    name: "Milk Tea",
    description: "Creamy tea with milk. Smooth and satisfying.",
    price: 10000,
    category: 'beverages',
    image: "https://images.unsplash.com/photo-1647759887093-bc5023ed586d",
    imageAlt: "Creamy milk tea in glass cup with milk swirl",
    dietary: [],
    ingredients: "Tea leaves, milk, sugar, hot water",
    nutrition: { calories: 120, protein: 4 },
    prepTime: 5,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 15,
    name: "Black Coffee",
    description: "Strong black coffee. Perfect for coffee lovers who enjoy it pure.",
    price: 7000,
    category: 'beverages',
    image: "/assets/images/6-1781077018551.jpeg",
    imageAlt: "Cup of black coffee with steam on dark background",
    dietary: [
    { label: 'Vegan', icon: 'Sprout' }],
    ingredients: "Coffee beans, hot water",
    nutrition: { calories: 5, protein: 0 },
    prepTime: 5,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  },
  {
    id: 16,
    name: "Cappuccino",
    description: "Classic cappuccino with rich espresso and creamy milk foam.",
    price: 10000,
    category: 'beverages',
    image: "https://images.unsplash.com/photo-1601819713498-eb04a642dee9",
    imageAlt: "Cappuccino with milk foam art in white cup on saucer",
    dietary: [],
    ingredients: "Espresso, steamed milk, milk foam",
    nutrition: { calories: 80, protein: 4 },
    prepTime: 5,
    servingSize: 1,
    isPopular: true,
    isFavorite: false
  }];


  const filteredAndSortedItems = useMemo(() => {
    let filtered = menuItems;

    if (activeCategory !== 'all') {
      filtered = filtered?.filter((item) => item?.category === activeCategory);
    }

    if (searchQuery) {
      filtered = filtered?.filter((item) =>
      item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      item?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      item?.ingredients?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      );
    }

    if (dietaryFilter !== 'all') {
      filtered = filtered?.filter((item) =>
      item?.dietary?.some((diet) => diet?.label?.toLowerCase()?.includes(dietaryFilter?.toLowerCase()))
      );
    }

    if (priceFilter !== 'all') {
      filtered = filtered?.filter((item) => {
        if (priceFilter === 'budget') return item?.price < 500;
        if (priceFilter === 'mid') return item?.price >= 500 && item?.price <= 1000;
        if (priceFilter === 'premium') return item?.price > 1000;
        return true;
      });
    }

    const sorted = [...filtered]?.sort((a, b) => {
      if (sortBy === 'popular') {
        return (b?.isPopular ? 1 : 0) - (a?.isPopular ? 1 : 0);
      }
      if (sortBy === 'price-low') return a?.price - b?.price;
      if (sortBy === 'price-high') return b?.price - a?.price;
      if (sortBy === 'name') return a?.name?.localeCompare(b?.name);
      return 0;
    });

    return sorted;
  }, [activeCategory, searchQuery, dietaryFilter, priceFilter, sortBy]);

  const handleWhatsAppOrder = (itemId) => {
    const item = menuItems?.find((i) => i?.id === itemId);
    if (item) {
      const message = `Hello Chapati Plus! I would like to order:\n\n${item?.name}\nPrice: ${item?.price} SSP\n\nPlease confirm availability.`;
      window.open(`https://wa.me/211911027181?text=${encodeURIComponent(message)}`, '_blank');
    }
  };

  const handleAddToFavorites = (itemId) => {
    const item = menuItems?.find((i) => i?.id === itemId);
    console.log(`Item ${itemId} favorite status: ${item?.isFavorite}`);
  };

  return (
    <>
      <Helmet>
        <title>Menu - Chapati Plus | Authentic South Sudanese Cuisine</title>
        <meta name="description" content="Explore our delicious menu featuring authentic South Sudanese chapati, rice dishes, meat platters, and vegetarian options. Fresh ingredients, traditional flavors, affordable prices." />
        <meta name="keywords" content="chapati menu, South Sudan food, rice dishes, meat platters, vegetarian food, Juba restaurant, food delivery" />
      </Helmet>
      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        
        <main className="flex-1 pt-16">
          <MenuHero />
          
          <CategoryFilter
            categories={categories}
            activeCategory={activeCategory}
            onCategoryChange={setActiveCategory} />

          
          <FilterBar
            dietaryFilter={dietaryFilter}
            onDietaryFilterChange={setDietaryFilter}
            priceFilter={priceFilter}
            onPriceFilterChange={setPriceFilter}
            sortBy={sortBy}
            onSortChange={setSortBy}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery} />


          <section className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                  {activeCategory === 'all' ? 'All Menu Items' : categories?.find((c) => c?.id === activeCategory)?.name}
                </h2>
                <p className="text-sm md:text-base text-muted-foreground">
                  Showing {filteredAndSortedItems?.length} {filteredAndSortedItems?.length === 1 ? 'item' : 'items'}
                </p>
              </div>
            </div>

            <MenuGrid
              items={filteredAndSortedItems}
              onOrderClick={handleWhatsAppOrder}
              onFavoriteToggle={handleAddToFavorites} />

          </section>

          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <QuickOrderBanner />
          </div>
        </main>

        <Footer />
      </div>
    </>);

};

export default Menu;